import React, { useContext } from 'react';
import './aboutwisedrive.css';
import { Divider } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import { MyContext } from '../../context';

function AboutWiseDrive() {
  const { pageData } = useContext(MyContext);

  return (
    <section style={{ marginTop: '20px' }}>
      <div className="container">
        <p>{pageData?.aboutUsPage?.header}</p>
        <div className="about-wisedrive-header">
          <h1 style={{ width: '60%', fontSize: '55px' }}>
            {pageData?.aboutUsPage?.leftHeader}
          </h1>
          <p style={{ width: '50%', fontFamily: 'matter' }}>
            {pageData?.aboutUsPage?.rightContent}
          </p>
        </div>
        <div className="about-wisedrive-flex">
          <div className="about-wisedrive-inFlex">
            {pageData?.aboutUsPage?.cardContent?.map((data, index) => (
              <div className="about-wisedrive-inFlex-content">
                <h2>{data?.header}</h2>
                <p>{data?.description}</p>
                <p style={{ fontSize: '14px', fontFamily: 'matter' }}>
                  {data?.subTitle}
                </p>
              </div>
            ))}
          </div>
        </div>
        <Divider sx={{ marginTop: '3rem', marginBottom: '3rem' }} />
        <p>{pageData?.aboutUsPage?.headerDesc}</p>
        <h2 style={{ fontFamily: 'matterSemiBold', marginBottom: '0px' }}>
          {pageData?.aboutUsPage?.header2}
        </h2>
        <p style={{ fontFamily: 'matter' }}>
          {pageData?.aboutUsPage?.subTitle}
        </p>
        <div className="about-wisedrive-inFlex">
          <div style={{ width: '100%' }}>
            <p style={{ fontFamily: 'matter' }}>
              {pageData?.aboutUsPage?.missionLeftContent}
            </p>
            <h6 style={{ marginTop: '10px' }}>
              {pageData?.aboutUsPage?.missionLeftHeader}
            </h6>
            {pageData?.aboutUsPage?.missionLeftPoints?.map((data, index) => (
              <p style={{ fontFamily: 'matter' }}>
                <DoneIcon /> {data}
              </p>
            ))}
          </div>
          <div style={{ width: '100%' }}>
            <p style={{ fontFamily: 'matter' }}>
              {pageData?.aboutUsPage?.missionRightContent}
            </p>
            <h6 style={{ marginTop: '10px' }}>
              {pageData?.aboutUsPage?.missionRightHeader}
            </h6>
            {pageData?.aboutUsPage?.missionRightPoints?.map((data, index) => (
              <p style={{ fontFamily: 'matter' }}>
                <DoneIcon />
                {data}
              </p>
            ))}
            <p style={{ fontFamily: 'matter' }}>
              {pageData?.aboutUsPage?.missionRightFooter}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutWiseDrive;
